import React from 'react';

const temporaryStyles = {
  position: 'absolute',
  top: 'calc(50% - 50px)',
  left: 'calc(50% - 100px)',
};

const NotFound = () => (
  <div style={temporaryStyles}>
    <h2 className="heading">Page Not Found</h2>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js